import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["path", "handleChanged", "autoOpen", "autoSelect", "transformFromConfig", "transformToConfig", "fullWidth", "url", "textFieldProps"];
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import AsyncComboBox from "../../base/AsyncComboBox";
import { useConfigurationData } from "../utils/ConfigurationComponentUtils";
import { HtmlString } from "../../Utils";
import ConfigurationSetToNull from "./ConfigurationSetToNull";
var ConfigurationAsyncComboBox = function ConfigurationAsyncComboBox(_ref) {
  var path = _ref.path,
    handleChanged = _ref.handleChanged,
    autoOpen = _ref.autoOpen,
    autoSelect = _ref.autoSelect,
    transformFromConfig = _ref.transformFromConfig,
    transformToConfig = _ref.transformToConfig,
    fullWidth = _ref.fullWidth,
    url = _ref.url,
    textFieldProps = _ref.textFieldProps,
    autocompleteProps = _objectWithoutProperties(_ref, _excluded);
  var _useConfigurationData = useConfigurationData(path),
    _useConfigurationData2 = _slicedToArray(_useConfigurationData, 2),
    data = _useConfigurationData2[0],
    setData = _useConfigurationData2[1];
  var handleChange = function handleChange(event, value) {
    var dataClone = _objectSpread({}, data);
    dataClone.value = transformToConfig ? transformToConfig(value) : value;
    dataClone.blankValue = dataClone.value === "";
    setData(dataClone);
    if (handleChanged) {
      handleChanged(dataClone.value);
    }
  };
  return /*#__PURE__*/React.createElement(AsyncComboBox, Object.assign({
    url: url ? url : data.url,
    autoOpen: autoOpen,
    autoSelect: autoSelect,
    textFieldProps: _objectSpread({
      label: data.label,
      fullWidth: fullWidth,
      helperText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfigurationSetToNull, {
        data: data,
        setData: setData
      }), /*#__PURE__*/React.createElement(HtmlString, {
        text: data.description
      }))
    }, textFieldProps),
    value: transformFromConfig ? transformFromConfig(data.value) : data.value,
    onChange: handleChange
  }, autocompleteProps));
};
export default ConfigurationAsyncComboBox;